export const API_URL = 'https://jsonplaceholder.typicode.com/photos';